import { cache } from 'react';

import { Dict, Lang, _t } from '@/lib/i18n';
import { LANGUAGES } from '@/lib/locales';
import ar from '@/public/assets/Images/flags/ar.png';
import en from '@/public/assets/Images/flags/en.png';
import es from '@/public/assets/Images/flags/es.png';
import fr from '@/public/assets/Images/flags/fr.png';
import hi from '@/public/assets/Images/flags/hi.png';
import id from '@/public/assets/Images/flags/id.png';
import pt from '@/public/assets/Images/flags/pt.png';
import ru from '@/public/assets/Images/flags/ru.png';
import th from '@/public/assets/Images/flags/th.png';
import vi from '@/public/assets/Images/flags/vi.png';
import zh from '@/public/assets/Images/flags/zh.png';

export type LanguageType = { name: string; flag: any; link: string };

const flags: Record<string, any> = { en, pt, es, zh, ru, hi, ar, fr, id, th, vi };

// The list itself lives in lib/locales.ts (shared with middleware); here only the flags are added
export const languages: LanguageType[] = LANGUAGES.map(({ link, name }) => ({
  flag: flags[link],
  link,
  name,
}));

interface DictonariesType {
  [key: string]: () => Promise<Dict>;
}

const dictionaries: DictonariesType = {};

languages.forEach(({ link }) => {
  dictionaries[link] = () =>
    import(`@/public/translations/${link}.json`).then((module) => module.default);
});

// cache(): layout, generateMetadata and the page all ask for the dictionary — load it once per request
export const getDictionary = cache(async (lang: Lang = 'en') =>
  ((await dictionaries[lang]) || dictionaries.en)());

export type Translator = (key: string) => string;

export const getTranslations = async (lang: Lang = 'en'): Promise<Translator> => {
  const dict = await getDictionary(lang);
  return (key: string) => _t(key, dict);
};
